import React, { useState } from 'react'
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    special_request: "",
  });
  const [responseMessage, setResponseMessage] = useState("");
  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://inmortaltechnologies.com/technociv/technociv.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(formData).toString(),
      });

      const result = await response.text();
      setResponseMessage(result);
      // console.log(result)
      // console.log(formData)
      alert(responseMessage);
      if (response.ok) {
        setFormData({
          name: "",
          email: "",
          subject: "",
          special_request: "",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setResponseMessage("Failed to submit the form.");
    }
  };

  return (
    <>
      <div>
        <section class="inner-banner">
          <div class="thm-container">
            <h2>Contact Us</h2>
            <div class="breadcumb">
              <a href="/">Home</a>
              <i class="fa fa-angle-right"></i>
              <span>Contact Us</span>
            </div>
          </div>
        </section>
        <div class="full_wrapper padtb_92_100">
          <div class="container">
            <h3 class="mbot25">Get In Touch</h3>
            <p class="mbot45">•	Innovative Environment: Be part of a team that values creativity and innovation, pushing the boundaries of technology in various engineering disciplines.</p>
            <div class="row">
              <div class="col-md-8  col-lg-8 col-md-8 col-sm-12 col-xs-12 text-center" >
                <div role="form" class="wpcf7" id="wpcf7-f322-p323-o1" lang="en-US" dir="ltr">
                  <div class="screen-reader-response"></div>
                  <form onSubmit={handleSubmit} action="/demosd/metallex1/?page_id=323#wpcf7-f322-p323-o1" method="post" class="wpcf7-form" novalidate="novalidate">

                    <div id="contact-form" class="full_width">

                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group faq_form-group">
                            <span class="wpcf7-form-control-wrap your-name">
                              <input type="text" name="name" value={formData.name}
                                onChange={handleChange} size="40" class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control faq_form_control" aria-required="true" aria-invalid="false" placeholder="Name" />
                            </span></div>
                          <div class="help-block with-errors"></div></div></div>
                    </div>
                    <div id="contact-form" class="full_width">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group faq_form-group">
                            <span class="wpcf7-form-control-wrap your-email">
                              <input type="email" name="email" value={formData.email} onChange={handleChange} size="40" class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email form-control faq_form_control" aria-required="true" aria-invalid="false" placeholder="Email" />
                            </span></div>
                          <div class="help-block with-errors"></div></div></div>
                    </div>
                    <div id="contact-form" class="full_width">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group faq_form-group">
                            <span class="wpcf7-form-control-wrap your-subject"><input type="text" name="subject" onChange={handleChange} value={formData.subject} size="40" class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control faq_form_control" aria-required="true" aria-invalid="false" placeholder="Subject" />
                            </span></div>
                          <div class="help-block with-errors"></div></div></div>
                    </div>
                    <div id="contact-form" class="full_width">
                      <div class="row">
                        <div class="col-md-12 mbot5">
                          <div class="form-group faq_form-group">
                            <span class="wpcf7-form-control-wrap your-message">
                              <textarea name="special_request" value={formData.special_request} onChange={handleChange} cols="40" rows="4" class="wpcf7-form-control wpcf7-textarea form-control faq_form_control faq_message_height" aria-invalid="false" placeholder="Special Request"></textarea>
                            </span></div>
                          <div class="help-block with-errors"></div></div></div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 mtop20">
                        <input type="submit" value="Submit Now" class="wpcf7-form-control wpcf7-submit btn submit_now faq_submit_btn contact_btn" />
                      </div>
                    </div>
                    <div class="wpcf7-response-output wpcf7-display-none">

                    </div>

                  </form>

                </div>
              </div>
              <div class="col-md-4  col-lg-4 col-md-4 col-sm-12 col-xs-12 plft85 col_margin" >

                <ul class="contact_info">
                  <li class="cnt_map_icon">
                    <p class="line_he2">Technociv Technologies pvt. Ltd.<br />
                      B-39, First Floor, B Block, Sector 64, Noida, UP-201301</p>
                  </li>
                  <li class="cnt_mail_icon">
                    <p class="line_he2">	info@technociv.com / sales@technociv.com<br />
                      {/* support@landscaping.com */}
                    </p>
                  </li>
                  <li class="cnt_call_icon">
                    <p class="line_he2">	+91-9999445570 / 99580 20570 / +91120-4573907</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="wpb_raw_code wpb_content_element wpb_raw_html">
          <div class="wpb_wrapper">
            <div class="full_width contact_map">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.5784413929928!2d77.37487667632224!3d28.612420875675653!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cef415122e055%3A0x4e37f79d564948aa!2sTechnociv%20Technologies%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1721206167593!5m2!1sen!2sin"
                width="600" height="450" style={{ border: "0" }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
      </div>
    </>

  )
}

export default Contact
